module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAqUlEQVRYhe2UUQ4DIQhEh8Z7lZspN8OT0a/daLO6TVe6acL7UiQZxBEgCIIgCIKbITPbNyJik9xl5JyJiAAAqRVnZndxVQURGQACgMevxd9JImI5Z3dxETmM709Qa10mxk/e11p1mpump9/SXpZHSY4FKOvHuV0BRya5ypm5uwI8zHjmra6AkVOv8F8dWPkVR5RSYGb9KPZo/Uy8jZGZbbPZnVZ860BwOy+ElUEGEiHu4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/CDRIVE_32.png
// module id = 46
// module chunks = 0